import * as cssVariable from 'cssVariables';
import { Styles } from 'jss';
import { StyleTheme } from 'components/theme/StyleTheme';

export default (theme: StyleTheme): Styles => ({
  tagTileHeight: {},
  showTileHeight: {},

  container: {
    position: 'relative',
    paddingTop: '100%',

    '&$tagTileHeight': {
      paddingTop: '60%',
    },
    '&$showTileHeight': {
      paddingTop: '130%',
    },
    '& $tileLink': {
      position: 'absolute',
      top: 0,
    },
  },

  touchContainer: {
    '& $title': {
      fontSize: cssVariable.fontSizes.xsmall,
    },
    '& $iconContainer': {
      width: 43,
      height: 43,
    },

    '&$tagTileHeight': {
      '& $title': {
        fontSize: cssVariable.fontSizes.xxsmall,
      },
      '& $iconContainer': {
        width: 33,
        height: 33,
      },
    },
  },

  tileLink: {
    background: cssVariable.white,
    border: `solid 1px ${cssVariable.grey300}`,
    borderRadius: 4,
    width: '100%',
    height: '100%',
    textAlign: 'center',
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: 10,

    '&:hover': {
      textDecoration: 'none',
    },
  },
  iconContainer: {
    display: 'inline-block',
    color: cssVariable.green500,
    width: 53,
    height: 53,
  },
  title: {
    color: cssVariable.grey500,
    fontSize: cssVariable.fontSizes.medium,
    margin: '10px 0 0',
  },

  [theme.breakpoints.down('md')]: {
    title: {
      fontSize: cssVariable.fontSizes.xsmall,
    },
    iconContainer: {
      width: 43,
      height: 43,
    },

    tagTileHeight: {
      '& $title': {
        fontSize: cssVariable.fontSizes.xxsmall,
      },
      '& $iconContainer': {
        width: 33,
        height: 33,
      },
    },
  },
});
